import Vue from 'vue'
import Vuex from 'vuex'
import apiClient from '@/services/apiClient'

Vue.use(Vuex)

export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_API;
import notify from 'devextreme/ui/notify';

const SESSION_KEYS = ['jwt','token','SesionID','NomUs','ApeUs','IDPU','IDUS','mail','NomP','RFCP','PAISP','PRem','PEI','FSF','IDUSiga','AREu','SUBc']
function clearSession() {
  SESSION_KEYS.forEach(k => localStorage.removeItem(k))
}


export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || ''
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, token){
      state.status = 'success'
      state.token = token
    },
    auth_error(state){
      state.status = 'error'
    },
    logout(state){
      state.status = ''
      state.token = ''
    }
    
  },
  actions: {
    recuperar({commit}, datos){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        apiClient.put('/api/General/updRecuperarContrasena', {
          Correo: datos.email,
          FormatoXML: false
        }, { withLenguaje: true })
        .then(resp => {
          commit('auth_success')
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          reject(err)
        })
      })
    },
    login({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        apiClient.post('/api/auth/login', {
          Usuario: user.email,
          Contrasena: user.password,
          FormatoXML: 0
        }, { withLenguaje: true })
        .then(resp => {
          const data = resp.data
          if (data.Estatus === 'OK') {
            const AdmonValidate = data.Correo.toLowerCase().includes('arendal.com.mx') ? 1 : 0
            const Subcontratista = AdmonValidate ? 1 : data.Subcontratista
            localStorage.setItem('jwt', data.JWT)
            localStorage.setItem('token', data.SesionID)
            localStorage.setItem('SesionID', data.SesionID)
            localStorage.setItem('NomUs', data.Nombre)
            localStorage.setItem('ApeUs', data.Apellido)
            localStorage.setItem('IDPU', data.Id_ProveedorUsuario)
            localStorage.setItem('IDUS', data.Id_Proveedor)
            localStorage.setItem('mail', data.Correo)
            localStorage.setItem('NomP', data.NombreProveedor)
            localStorage.setItem('RFCP', data.RFC_Proveedor)
            localStorage.setItem('PAISP', data.Pais_Proveedor)
            localStorage.setItem('PRem', data.PermitirNotasRemision)
            localStorage.setItem('PEI', data.PermitirEnviosInternos)
            localStorage.setItem('FSF', data.FlagSubirFacturas)
            localStorage.setItem('IDUSiga', data.Id_UsuarioSIGA)
            localStorage.setItem('AREu', AdmonValidate)
            localStorage.setItem('SUBc', Subcontratista)
            commit('auth_success', data.SesionID)
          } else {
            commit('auth_error')
            clearSession()
          }
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          clearSession()
          reject(err)
        })
      })
    },
    logout({commit}, SesionID){
      return new Promise((resolve, reject) => {
        apiClient.post('/api/auth/logout', {
          SesionID: SesionID.SesionID,
          FormatoXML: false
        }, { withLenguaje: true })
        .then(resp => {
          commit('logout')
          const data = resp.data
          if (data && data.Estatus === 'OK') {
            notify(data.Mensaje, 'success')
          }
          resolve(resp)
        })
        .catch(err => {
          commit('logout')
          reject(err)
        })
        .finally(() => {
          clearSession()
        })
      })
    }
  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
  }
})